import { alpha, styled } from '@mui/material';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

const StepperRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  marginRight: -6,
  '& button': {
    display: 'grid',
    placeItems: 'center',
    width: 18,
    height: 11,
    padding: 0,
    borderRadius: 4,
    border: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    color: theme.palette.info.main,
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color', 'color']),
    '& svg': { fontSize: 13 },
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      color: theme.palette.primary.main,
    },
    '&:disabled': { opacity: 0.4, cursor: 'default' },
  },
}));

type Props = {
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
};

export default function NumberStepper({ onIncrement, onDecrement, disabled }: Props) {
  return (
    <StepperRoot>
      <button type="button" tabIndex={-1} aria-label="Increment" disabled={disabled} onClick={onIncrement}>
        <KeyboardArrowUpRoundedIcon />
      </button>
      <button type="button" tabIndex={-1} aria-label="Decrement" disabled={disabled} onClick={onDecrement}>
        <KeyboardArrowDownRoundedIcon />
      </button>
    </StepperRoot>
  );
}
